import { portalText, usePortalTranslation } from "../../i18n/portal.js";
/**
 * The "New messages" button (FR-SC-3, unit WC-10): shown when a line arrived while the reader was
 * scrolled up to read earlier ones. A real `<button>`, so it is reached with the keyboard; it sits
 * outside the `role="log"` region so a screen reader does not announce it as a reply. Activating it
 * scrolls to the newest line (`useStickToBottom().jumpToNewest`).
 */
import { Button, Icon } from "@wetalk/ui";
import type { ReactNode } from "react";

import { GLYPH } from "../../shell/glyph.js";

import "./test-console.css";

export function NewestLineButton({ onJump }: { readonly onJump: () => void }): ReactNode {
  usePortalTranslation("operations");
  return (
    <div className="c-newest">
      <Button variant="secondary" onClick={onJump}>
        <Icon glyph={GLYPH.caretDown} size="md" />
        {portalText("operations", "new_messages_6d867124")}</Button>
    </div>
  );
}
